"use client";

import { create } from "zustand";
import { MyProductsViewState } from "../types";

export const useMyProductsViewStore = create<MyProductsViewState>((set) => ({
  viewMode: "credits",
  setViewMode: (v) => set({ viewMode: v }),
}));
